import { styled } from 'styled-components';

export const ErrorPageWrapper = styled.div`
  position: fixed;
  top: ${({ $top }) => `calc(${$top} + 0.5rem)` || '3.5rem'};
  ${({ theme }) => theme.mqFrom('md')} {
    left: 64px;
    width: calc(100vw - 73px);
  }
  left: 0.5rem;
  background-color: ${({ theme }) =>
    theme.colours.visualisations.base.background};
  width: calc(100vw - 1rem);
  height: ${({ $top }) =>
    `calc(100vh - (${$top} + 1rem))` || 'calc(100vh - 1rem)'};
`;
ErrorPageWrapper.displayName = 'ErrorPageWrapper';

export const ErrorPageContent = styled.div`
  position: relative;
  top: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  gap: ${({ theme }) => theme.sizing.tiny};
  height: 100%;

  a {
    text-decoration: underline;
  }

  svg {
    margin: 0 auto;
    fill: ${({ theme }) => theme.colours.messaging.warning.main} !important;
  }
`;
ErrorPageContent.displayName = 'ErrorPageContent';
